<template>
  <div class="wr-not-found">
    <div class="container py-5">
      <div class="d-flex align-items-center justify-content-center mb-4">
        <AppLogo />
      </div>
      <div class="col-lg-6 mx-auto py-5 wr-not-found__content wr-radius-3">
        <div
          class="d-flex flex-column align-items-center justify-content-center"
        >
          <div class="wr-lottie-item py-5">
            <LottieAnimation
              ref="anim"
              :animationData="require('@/assets/lottie/404.json')"
              loop
              :speed="1"
              :autoPlay="true"
            />
          </div>
          <div class="text-center col-lg-8 mx-auto">
            <h4 class="wr-text__h3 wr-text--dark">Page Not Found</h4>
            <p class="wr-text__body wr-text--dark opacity-50">
              The page you are looking for does not exist or may have been
              moved. That's all we know
            </p>
          </div>
          <div class="mt-4">
            <router-link
              :to="
                isAuthenticated
                  ? dashboardPaths['overview']
                  : authPaths['login']
              "
              class="wr-button wr-button--small wr-bg--success-muted wr-text--primary-2 px-3"
            >
              Back to familiar grounds
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { useHead } from "unhead";
import { useStore } from "vuex";
import { computed } from "vue";
import { dashboardPaths } from "@/router/path.route";
import { authPaths } from "@/router/path.route";
export default {
  setup() {
    useHead({
      title: "Page Not Found!",
    });
    const store = useStore();
    const isAuthenticated = computed(() => store.getters.isAuthenticated);
    return {
      dashboardPaths,
      authPaths,
      isAuthenticated,
    };
  },
};
</script>

<style scoped>
.wr-not-found .wr-not-found__content {
  box-shadow: var(--wr-shadow-1);
}
</style>
